const config = {
  CURRENT_SITE:
    window.drupalSettings && window.drupalSettings.pageInfo
      ? window.drupalSettings.pageInfo.site
      : "bruzzket",
  CLEVERCAST: {
    ACCOUNT_ID: "WXv1JD",
  },
};

export default config;
